import React from 'react';
import { Toaster } from 'react-hot-toast';
import AppProviders from './providers/AppProviders';
import AppRoutes from './AppRoutes';
import AppShell from './AppShell';
import RealtimeAlerts from './components/RealtimeAlerts';

export default function App() {
  return (
    <AppProviders>
      <div className="app">
        <RealtimeAlerts />
        <AppShell>
          <AppRoutes />
        </AppShell>
        <Toaster position="top-center" toastOptions={{ duration: 3000, style: { fontSize: '14px' } }} />
      </div>
    </AppProviders>
  );
}
